import { AppState } from '../index';
import * as fromAgreements from './agreements.reducer';
import { createSelector } from '@ngrx/store';
import { AGREEMENT_TYPE, Agreement } from '../../model/agreements.model';
import AppError from '../../model/app-error';

export const selectAgreementsState = createSelector(
  (state: AppState) => state.agreements,
  ({ state }: fromAgreements.State) => state,
);

export const selectMarketingAgreementsData = createSelector(
  (state: AppState) => state.agreements,
  ({ data }: fromAgreements.State): Agreement[] | undefined => data?.marketing,
);

export const selectStatementsAgreementsData = createSelector(
  (state: AppState) => state.agreements,
  ({ data }: fromAgreements.State): Agreement[] | undefined => data?.statements,
);

export const selectStatementsAgreementsError = createSelector(
  (state: AppState) => state.agreements,
  ({ error }: fromAgreements.State): AppError | null => error,
);

export const selectIsAnyRequiredAgreement = createSelector(
  (state: AppState) => state.agreements,
  ({ data }: fromAgreements.State): boolean =>
    (data?.[AGREEMENT_TYPE.MARKETING].some((item) => item.isRequired) ||
      data?.[AGREEMENT_TYPE.STATEMENTS].some((item) => item.isRequired)) ??
    false,
);
